import React from "react";

export default function TextArea({
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  rows = 3,
}) {
  return (
    <div className="form-group mb-3">
      {label && <label className="form-label fw-semibold mb-1 text-lg">{label}</label>}
      <textarea
        value={value || ""}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        rows={rows}
        className={`form-control ${error ? "is-invalid" : ""}`}
      ></textarea>
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
}
